/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { ErrorCode } from '../entities/ErrorCode'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { z } from 'zod'

export const errorCodeSchema = z.union([
  z.literal(0),
  z.literal(1),
  z.literal(1000),
  z.literal(1001),
  z.literal(1002),
  z.literal(1003),
  z.literal(1004),
  z.literal(1005),
  z.literal(1006),
  z.literal(1007),
  z.literal(1008),
  z.literal(1009),
  z.literal(1010),
  z.literal(1011),
  z.literal(1012),
  z.literal(1013),
  z.literal(2000),
  z.literal(3000),
  z.literal(3001),
  z.literal(3002),
  z.literal(4000),
  z.literal(4001),
  z.literal(4002),
  z.literal(5000),
  z.literal(5001),
  z.literal(5002),
  z.literal(5003),
  z.literal(5004),
]) as unknown as ToZod<ErrorCode>